import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: App,
  loader: () => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
      throw redirect({
        to: '/mobile'
      })
    }

    throw redirect({
      to: '/desktop'
    })
  },
  onError: () => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
      throw redirect({
        to: '/mobile'
      })
    }

    throw redirect({
      to: '/desktop'
    })
  }
})

function App() {
  return (
    <div />
  )
}
